module.exports = __webpack_public_path__ + "static/img/buy-tablecode.c67fc978.png";